<template>
  <div>
    <div v-if="value.rate">
      <div v-if="canEditRating">
        <a class="underline" @click="handleClickOpenFromEditRating">{{ value.rate }}</a>
      </div>
      <div v-else>
        {{ value.rate }}
      </div>
    </div>
    <div v-else>
      <sc-button
        :disabled="isViewOnlyByRole"
        variant="primary"
        size="sm"
        @click="handleClickOpenFromUpdateRating()"
        >ให้คะแนน</sc-button
      >
    </div>
    <confirm-dialog
      v-if="createRatingDialog.isShow"
      :data="createRatingDialog"
      @confirm="handleConfirmCreateRating"
    >
      <div class="row select-rating">
        <div class="col-3 mb-2 title-appoint">ชื่อผู้รับบริการ:</div>
        <div class="col-9 left">{{ name }}</div>
        <div class="col-3 mb-2 title-appoint">ชื่อบริการ:</div>
        <div class="col-9 left">{{ value.serviceName }}</div>
        <div class="col-6 mb-4 flex">
          <div class="title-appoint">วันที่รับบริการ:</div>
          <div class="padding-15">{{ value.appointmentAt }}</div>
        </div>
        <div class="col-6 mb-4 flex">
          <div class="title-appoint">วันที่ปิดงาน:</div>
          <div class="padding-15">{{ value.appointmentFulfilledAt }}</div>
        </div>
        <div class="col-4 mb-3">
          <label for="selectRating">ให้คะแนนความพึงพอใจ</label>
          <el-select
            id="selectRating"
            v-model="params.selectRating"
            clearable
            @change="autofillContactStatus"
          >
            <el-option
              v-for="t in ratingDropdown"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
          <div class="mt-3">
            <div
              v-for="ratingContactStatus in ratingContactStatusMapping"
              :key="ratingContactStatus.value"
            >
            <label class="select-input">
              <span>{{ ratingContactStatus.label }}</span>
              <input
                v-model="params.contactStatus"
                :value="ratingContactStatus.value"
                type="radio"
              />
              <span class="checkmark radio"></span>
            </label>
            </div>
          </div>
        </div>
        <div class="col-8">
          <label for="suggestionForRating" class="flex"
            >คำแนะนำ
          </label>
          <el-input
            id="suggestionForRating"
            v-model="params.suggestionForRating"
            type="textarea"
            rows="5"
          ></el-input>
        </div>
      </div>
    </confirm-dialog>
  </div>
</template>

<script>
import { Select, Option, Input } from "element-ui";
import ConfirmDialog from "@/components/helper/dialog/ConfirmDialog";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { existValueAndEmptyString } from "@/lib/util";
import { ratingContactStatusMapping } from "@/lib/mapper";
import { getAdminRolePermission } from "../adminRolePermission";

export default {
  components: {
    "confirm-dialog": ConfirmDialog,
    "sc-button": ScButton,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const createRatingDialog = {
      isShow: false,
      title: "ให้คะแนนความพึงพอใจ",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ยืนยัน",
    };
    const permission = getAdminRolePermission();

    return {
      createRatingDialog,
      params: {
        selectRating: null,
        suggestionForRating: null,
        contactStatus: null,
      },
      ratingContactStatusMapping,
      permission
    };
  },
  computed: {
    ratingDropdown() {
      const rating = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
      ];

      if (!existValueAndEmptyString(this.value.rate)) {
        rating.push({ label: "N/A", value: "CAN_NOT_RATE" })
      }

      return rating
    },
    name() {
      return `${this.value.firstName} ${this.value.lastName}`;
    },
    canEditRating() {
      if (!existValueAndEmptyString(this.value.submittedRatingFormAt))
        return true;

      const submittedRatingAt = DateTime.fromFormat(
        this.value.submittedRatingFormAt,
        "dd/MM/yyyy"
      );

      const now = DateTime.utc().startOf("day");

      const submittedRatingDiff = now.diff(submittedRatingAt, [
        "years",
        "months",
        "days",
        "hours",
      ]);

      const isEditRating =
        submittedRatingDiff.days < 3 &&
        submittedRatingDiff.months === 0 &&
        submittedRatingDiff.years === 0;

      return isEditRating;
    },
    isViewOnlyByRole() {
      const roles = ["CDS"]
      return roles.includes(this.permission.role)
    },
  },
  watch: {},
  methods: {
    autofillContactStatus() {
      this.contactStatus = this.selectRating !== "" ? "CONTACTED" : "";
    },
    async handleConfirmCreateRating(isConfirm) {
      if (!isConfirm) {
        this.clearFormRating();
        return;
      }

      if (!this.params) {
        this.$message.error("ไม่สามารถบันทึก rating ได้");
        return;
      }

      if (!this.params.contactStatus || this.params.contactStatus === "") {
        this.$message.error("กรุณาใส่สถานะการติดต่อ");
        return;
      }

      try {
        const isUpdateRating = existValueAndEmptyString(this.value.ratingFormSubmissionId)
          && existValueAndEmptyString(this.value.ratingQuestionSubmissionsId)

        if (isUpdateRating === true) {
          await this.updateFormRating();
        } else {
          await this.createFormRating();
        }

        this.clearFormRating();
        this.$message.success("บันทึกการให้คะแนนสำเร็จ");
        this.$emit("reload");
      } catch (error) {
        this.$message.error("ไม่สามารถบันทึก การให้คะแนนความพึงพอใจ ได้");
      }
    },
    async createFormRating() {
      let selectRating = "CAN_RATE"
      if (existValueAndEmptyString(this.params.selectRating)) {
        if (this.params.selectRating === "N/A") {
          selectRating = "CAN_NOT_RATE"
        } else {
          selectRating = this.params.selectRating
        } 
      }
          
      const params = {
        appointment_id: this.value.appointmentId,
        service_id: this.value.serviceId,
        subscription_id: this.value.subscriptionId,
        home_id: this.value.homeId,
        user_id: this.value.userId,
        contact_status: this.params.contactStatus,
        select_rating: selectRating,
        suggestion_for_rating: this.params.suggestionForRating,
      };

      await baanRueJaiClient.admin.subscriptions.ratings.postFormRating(params);
    },
    async updateFormRating() {
      let selectRating = "CAN_RATE"
      if (existValueAndEmptyString(this.params.selectRating)) {
        if (this.params.selectRating === "N/A") {
          selectRating = "CAN_NOT_RATE"
        } else {
          selectRating = this.params.selectRating
        } 
      }
      const {appointmentId} = this.value;

      const params = {
        appointment_id: this.value.appointmentId,
        service_id: this.value.serviceId,
        subscription_id: this.value.subscriptionId,
        home_id: this.value.homeId,
        user_id: this.value.userId,
        contact_status: this.params.contactStatus,
        select_rating: selectRating,
        suggestion_for_rating: this.params.suggestionForRating,
        rating_form_submission_id: this.value.ratingFormSubmissionId,
        rating_question_submissions_id: this.value.ratingQuestionSubmissionsId
      };

      await baanRueJaiClient.admin.subscriptions.ratings.putFormRating(
        appointmentId,
        params
      );
    },
    clearFormRating() {
      this.params = {
        selectRating: null,
        suggestionForRating: null,
        contactStatus: null,
      };

      this.createRatingDialog.isShow = false;
    },
    handleClickOpenFromUpdateRating() {
      this.createRatingDialog.isShow = true;
    },
    handleClickOpenFromEditRating() {
      this.createRatingDialog.isShow = true;

      this.params.selectRating = this.value.rate.toString();
      this.params.contactStatus = this.value.contactStatus;
      this.params.suggestionForRating = this.value.comment;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.title-appoint {
  font-weight: bold;
}

.select-rating {
  text-align: left;
}

.red {
  color: rgb(250, 1, 1);
  padding-left: 5px;
}

.flex {
  display: flex;
}

.left {
  padding-left: 0;
}

.padding-15 {
  padding-left: 15px;
}

.underline {
  text-decoration: underline;
}
</style>
